import { mapBasePicture, mapUrlToPreview } from './BasePicture.mappers';
export const mapSecurePictureFileOutput = file => {
  var _file$media;
  const previewImage = (_file$media = file.media) == null || (_file$media = _file$media.image) == null ? void 0 : _file$media.previewImage;
  if (!previewImage) {
    return {
      preview: []
    };
  }
  const url = previewImage.url || '';
  return mapUrlToPreview(url, file.operationStatus, previewImage);
};
export const mapSecurePictureFile = (file, baseFile) => {
  const basePicture = mapBasePicture(file, baseFile);
  return {
    mediaType: 'secure_picture',
    fileOutput: mapSecurePictureFileOutput(file),
    ...basePicture
  };
};
//# sourceMappingURL=SecurePicture.mappers.js.map